<template>
  <div class="content">
    <div class="head">
      <div class="container">
        <div class="row">
          <img class="logoImg" src="../assets/img/logo.png" />
        </div>
      </div>
    </div>
    <div class="container">
      <button @click="initialize()">データベースを初期化する</button>
      <div v-if="text">{{ returnText }}</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "initialize",
  data() {
    return {
      text: false,
      returnText: "",
    };
  },
  methods: {
    initialize: function () {
      if (!window.confirm("データベースを初期化しますか?")) {
        return;
      }
      // ※OK時の処理
      let self = this;
      axios
        .put(self.$store.state.APIbase + "api/initialize")
        .then(() => {
          self.returnText = "データベースを初期化しました。";
          self.text = true;
          setTimeout(function () {
            self.text = false;
          }, 2000);
        })
        .catch(() => {
          self.returnText = "データベースの初期化に失敗しました。";
          self.text = true;
        });
    },
  },
};
</script>

<style scoped>
.head {
  width: 100%;
  height: 150px;
  min-height: 30px;
  background: #4690cf;
  text-align: center;
}
.container {
  text-align: center;
}
.logoImg {
  width: 200px;
  margin-top: 0;
}
button {
  padding-top: 10px;
  padding-bottom: 40px;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  transition: all 0.3s;
}
button:hover {
  transform: scale(1.1);
}
button:active {
  transform: scale(0.9);
}
</style>
